import { Types } from './types'

const initialState = {
    dataListPriorities: {
        rows: [],
        total: 0,
    },
    dataListPriorityBenefits: {
        rows: [],
        total: 0,
    },
    dataListPriorityRequests: {
        rows: [],
        total: 0,
    },
    dataListPriorityUsers: {
        rows: [],
        total: 0,
    },
    dataDetailListPriorityRequests: {
        rows: [],
        total: 0,
    },
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_PRIORITIES:
            return {
                ...newState,
                dataListPriorities: action.payload
            }
        case Types.SAVE_LIST_PRIORITY_BENEFITS:
            return {
                ...newState,
                dataListPriorityBenefits: action.payload
            }
        case Types.SAVE_LIST_PRIORITY_REQUESTS:
            return {
                ...newState,
                dataListPriorityRequests: action.payload
            }
        case Types.SAVE_LIST_PRIORITY_USERS:
            return {
                ...newState,
                dataListPriorityUsers: action.payload
            }
        case Types.SAVE_LIST_DETAIL_PRIORITY_REQUESTS:
            return {
                ...newState,
                dataDetailListPriorityRequests: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
